import { IAuth } from './IAuth';
import * as microsoftTeams from '@microsoft/teams-js';
import { makeAutoObservable } from 'mobx';

export class TeamsSSOAuth implements IAuth {
	context: microsoftTeams.app.Context | null = null;

	public contextLoad: Promise<microsoftTeams.app.Context>;

	constructor() {
		makeAutoObservable(this);

		this.contextLoad = new Promise<microsoftTeams.app.Context>(
			async (resolve, reject) => {
				await microsoftTeams.app.initialize();
				var ctx = await microsoftTeams.app.getContext();
				resolve(ctx);
			},
		);

		this.contextLoad.then(this.setTeamsContext.bind(this)).catch((reason) => {
			console.log('failed to load teams ' + reason);
		});
	}

	setValidityState(isTabValid: boolean) {
		try {
			microsoftTeams.pages.config.setValidityState(isTabValid);
		} catch {}
	}

	setTeamsContext(ctx: microsoftTeams.app.Context) {
		this.context = ctx;

		if (this.context.page.frameContext === 'settings') {
			microsoftTeams.pages.config.registerOnSaveHandler(
				async (saveEvent: microsoftTeams.settings.SaveEvent) => {
					/*
				//Build the request
				let request:ICreateProjectRequest = CreateProjectCtrlState.GetCreateProjectRequest(this._createProjectOptions, 
																ctx.team?.groupId || '',
																ctx.channel?.id  || '',
																ctx.sharePointSite?.teamSiteUrl || '');
				
				//Send the request
				let token = await this.getToken();
				let createProjectResult = await new API(token).createProject(request);	
				
				if(createProjectResult.id) {
					//Configure the tab to point to the new project
					const host = "https://" + window.location.host;
					microsoftTeams.pages.config.setConfig({
						contentUrl: host + "/#teamDashboardTab/" + createProjectResult.id,
						entityId: createProjectResult.id,
						suggestedDisplayName: "Dashboard"
					});
					saveEvent.notifySuccess();
				} else {
					let error = "Sorry, we couldn't create your dashboard. " + createProjectResult.error;
					saveEvent.notifyFailure(error);

				}*/
				},
			);

			microsoftTeams.pages.config.setValidityState(false);
			microsoftTeams.app.notifySuccess();
		}
	}

	login() {
		throw new Error('invalid operation');
	}

	logout() {
		throw new Error('invalid operation');
	}

	getToken = (): Promise<string> => {
		return new Promise<string>((resolve, reject) => {
			microsoftTeams.authentication
				.getAuthToken({})
				.then((token) => {
					resolve(token);
				})
				.catch((reason) => {
					reject(reason);
					microsoftTeams.app.notifyFailure({
						reason: microsoftTeams.app.FailedReason.AuthFailed,
						message: reason,
					});
				});
		});
	};
}
